"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pageTitle = require("@/utils/page-title");
//
//
//
//
//
//
var _default = {
  name: 'PageInfo',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      page: ''
    };
  },
  created: function created() {
    this.page = this.title || (0, _pageTitle.getPageName)(this.$route.meta.title);
  }
};
exports.default = _default;